<template>
  <div class="body login">
    <div class="div-block-5">
      <label for="email">Email</label>
      <input
        @keypress.enter="login()"
        v-model="email"
        type="email"
        class="login-field w-input"
        maxlength="256"
        name="email"
        data-name="email"
        placeholder="Email"
        id="email"
      />
      <label for="password">Password</label>
      <input
        @keypress.enter="login()"
        v-model="password"
        type="password"
        class="login-field w-input"
        maxlength="256"
        name="password"
        placeholder="Password"
        id="password"
      />
      <a @click="login()" class="button w-button">Register</a>
    </div>
    <img src="../assets/1bagelstudio_logo_white.svg" alt />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      email: "",
      password: "",
      error: ""
    };
  },
  methods: {
    login() {
      if (this.email && this.password) {
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(function() {
            vm.$router.push("/");
          })
          .catch(error => {
            // Handle Errors here.
            var errorCode = error.code;
            this.error = error.message;
            // ...
          });
      }
    }
  }
};
</script>

<style scoped>
 a.button.w-button{
    display: block;
    max-width: 200px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    }
.blue-txt.forgot{
    display: block;
    text-align: center;
    margin-bottom: 1px;
}

.div-block-5 {
    display: block;
    width: 90%;
    height: auto;
    max-width: 530px;
    padding-top: 30px;
    padding-bottom: 30px;
    padding-left: 50px;
    padding-right: 50px;
    align-items: center;
    border-radius: 5px;
    background-color: #fff;
}

.body {
  color: black;
  text-align: left;
  padding-top: calc(50vh - 265px);
}
label {
  font-weight: lighter;
  margin-top:20px;
}
.error {
  color: red;
  max-width: 80%;
  margin-right: auto;
  margin-left: auto;
  text-align: center;
}
input {
  background: #e8e8e8;
  color: black;
  width: 100%;
}

@media only screen and (max-width: 600px) {
.div-block-5 {
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
}
.body {
  padding-top: 10vh;
}
}
</style>